// AuthProtectedRoute.tsx - For AUTH SUBDOMAIN only
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuthenticator } from '@aws-amplify/ui-react'
import { hasActiveDeletionIntent } from '@utils/accountDeletion'

interface AuthProtectedRouteProps {
  children?: JSX.Element
}

/**
 * Protected route component for the auth subdomain.
 * Redirects unauthenticated users to /auth (local route, not cross-domain)
 */
const AuthProtectedRoute: React.FC<AuthProtectedRouteProps> = ({
  children,
}) => {
  const { authStatus } = useAuthenticator((context) => [context.authStatus])
  console.log('authStatus', authStatus)
  const location = useLocation()

  // Defer redirect until Amplify finishes determining the session state
  if (authStatus === 'configuring') return null

  // Unauthenticated users go to /auth with redirect parameter only if it exists
  if (authStatus !== 'authenticated') {
    // Only pass redirect parameter if it already exists in current URL
    const existingRedirect = new URLSearchParams(location.search).get(
      'redirect'
    )

    const shouldResumeDeletion = hasActiveDeletionIntent()
    const authPath = shouldResumeDeletion
      ? '/auth?action=delete_account'
      : existingRedirect
        ? `/auth?redirect=${encodeURIComponent(existingRedirect)}`
        : '/auth'

    return <Navigate to={authPath} replace />
  }

  return children ? children : <Outlet />
}

export default AuthProtectedRoute
